module.exports = __webpack_public_path__ + "static/media/Bellossom_gaussian2.e6d2ddd2.png";